import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import { fetchOrganizations } from '../../actions/organizationActions'
import { selectOrganizationIndex } from '../../reducers/organizationReducer'
import { parseQuery } from '../../helpers/queryHelper'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'

class OrganizationIndexComponent extends Component<any, { loading: boolean }> {
  state = { loading: true }

  componentDidMount() {
    this.load()
  }

  load = async () => {
    const { dispatch } = this.props
    this.setState({ loading: true })
    try {
      await dispatch(fetchOrganizations())
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const { organizations: allOrganizations, history, location } = this.props as {
      organizations: any[]
      history: History
      location: { search: string }
    }
    const nameFilter = String(
      (parseQuery(location.search) as any).name || ''
    ).toLowerCase()
    const organizations = nameFilter
      ? allOrganizations.filter((o) =>
          String(o.nameLegal || '')
            .toLowerCase()
            .includes(nameFilter)
        )
      : allOrganizations

    const levels = [
      { label: 'Index ', path: '/' },
      { label: 'Organizations', path: '/organizations' },
    ]

    return (
      <>
        <Breadcrumb levels={levels} />
        <LoadingSection isLoading={this.state.loading}>
          <div className="index index__drive-america">
            <h1 className="index-table__header">Organizations</h1>
            <div className="index-table__drive-america">
              <a
                href="/organizations/new"
                className="button button-drive-america link-drive-america link-drive-america__new-applicant"
              >
                New Organization
              </a>
            </div>
            <table className="index-table">
              <tbody className="index-table__body">
                {organizations.map((o) => (
                  <tr
                    key={o.id}
                    className="index-table__row"
                    onClick={() => history.push(`/organizations/${o.id}`)}
                  >
                    <td className="index-table__cell">{o.nameLegal}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </LoadingSection>
      </>
    )
  }
}

export default withRouter(
  connect((state) => ({
    organizations: selectOrganizationIndex(state.organizations),
  }))(OrganizationIndexComponent)
)
